import {EntityType} from "../core/entityType";
import {Operation} from "../core/operation";

export const entityType = EntityType.MyPermissions;
export const entityOperations = [
  Operation.getAll
];
